<template>
	<div ref="content" class="content background2">
		<div ref="search">
			<SearchList ref="searchContent" :searchList="searchList"></SearchList>
		</div>
		<div ref="btnList">
			<BtnList ref="btn" :btnList="btnList"></BtnList>
		</div>
		<div ref="tableList" class="list" :style="{'padding-top':paddingTop}">
			<List ref="list" :tableData="tableData" :tableList="tableList" :pageSize="pageSize" :pageNo="pageNo"
				@parentMethod="getInfo"></List>
		</div>
		<div ref="page" class="page">
			<Page ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
				@parentMethod="search"></Page>
		</div>
	</div>
</template>

<script>
	import "@/assets/css/common/list.css"
	import SearchList from "@/components/list/searchList";
	import BtnList from "@/components/list/btnList";
	import List from "@/components/list/list";
	import Page from "@/components/common/page";
	import User from "@/assets/js/system/user.js";
	export default {
		name: 'list',
		components: {
			List,
			SearchList,
			BtnList,
			Page
		},
		data() {
			const $this = this;
			return {
				paddingTop: 0,
				searchList: [{
						searchLabel: '行政编码',
						searchValue: '',
						searchType: 0,
						searchWidth: '25%',
						searchBr: false,
						column: 'areaCode',
					},
					{
						searchLabel: '名称',
						searchValue: '',
						searchType: 0,
						searchWidth: '25%',
						searchBr: false,
						column: 'name',
					},
					{
						searchLabel: '经度',
						searchValue: '',
						searchType: 0,
						searchWidth: '25%',
						searchBr: false,
						column: 'lng',
					},
					{
						searchLabel: '纬度',
						searchValue: '',
						searchType: 0,
						searchWidth: '25%',
						searchBr: false,
						column: 'lat',
					},
				],
				btnList: [],
				tableData: [],
				tableList: [{
					column: 'areaCode',
					title: '行政编码',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}, {
					column: 'name',
					title: '名称',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}, {
					column: 'lng',
					title: '经度',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}, {
					column: 'lat',
					title: '纬度',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}],
				tableInfo: {},
				pageCount: 0,
				pageSize: 0,
				pageNo: 1,
			}
		},
		methods: {
			queryArea() {},
			post(param) {
				this.utils.startLoading();
				User.getAreaMesList(param).then((response) => {
					const data = response.data;
					this.utils.endLoading();
					this.pageCount = data.data.total;
					this.pageNo = data.data.current;
					this.$refs['pageModel'].setCurrent(this.pageNo);
					this.tableData = data.data.records;
				}).catch((response) => {})
			},
			search(param) {
				var dataParam = this.$refs.searchContent.getSearchParam();
				var newParam = Object.assign(param, dataParam);
				this.post(newParam);
			},
			getWindowHeight() {
				let height = '';
				height = this.$refs.tableList.clientHeight - (this.$refs.search.clientHeight + this.$refs.btnList
					.clientHeight +
					20) - 60;
				this.height = height;
				if (height > 550) {
					let line = parseInt((height - 10) / 50);
					if (this.pageSize != line) {
						this.pageSize = line;
					}
				} else {
					if (this.pageSize != 10) {
						this.pageSize = 10;
					}
				}
				this.search({
					pageNo: 1,
					pageSize: this.pageSize
				});
			},
			getInfo(info) {
				this.tableInfo = info;
			}
		},
		created() {
			const $this = this;
			this.menuList = this.$store.getters.getMenuPermission;
			if (this.menuList.indexOf("CD_631") != -1) {
				this.btnList.push({
					btnLabel: '新增',
					btnType: 1,
					btnPosition: 'left',
					title: '新增',
					columnList: [{
							columnLabel: '行政编码',
							value: '',
							column: 'areaCode',
							columnType: 0,
							placeholder: '请输入行政编码',
						},
						{
							columnLabel: '名称',
							value: '',
							column: 'name',
							columnType: 0,
							placeholder: '请输入名称',
						}, {
							columnLabel: '经度',
							value: '',
							column: 'lng',
							columnType: 0,
							placeholder: '请输入经度',
						},
						{
							columnLabel: '纬度',
							value: '',
							column: 'lat',
							columnType: 0,
							placeholder: '请输入纬度',
						},
					],
					btnClick: function(tip) {
						tip();
						$this.btnList[0].columnList.forEach(function(item, index) {
							item.value = '';
						})
					},
					btnFun: function(tip, info) {
						if (info.lat == '') {
							this.utils.tipsAlert('纬度不能为空');
							return;
						}
						if (info.lng == '') {
							this.utils.tipsAlert('经度不能为空');
							return;
						}
						if (info.name == '') {
							this.utils.tipsAlert('名称不能为空');
							return;
						}
						if (info.areaCode == '') {
							this.utils.tipsAlert('行政编码不能为空');
							return;
						}
						info.lat = Number(info.lat)
						info.lng = Number(info.lng)
						info.areaCode = Number(info.areaCode)
						$this.utils.tipsAlert()
						$this.utils.startLoading();
						User.addArea(info).then((response) => {
							const data = response.data;
							if (data.code == 1) {
								$this.utils.endLoading();
								$this.utils.saveAlert();
								$this.search({
									pageNo: 1,
									pageSize: $this.pageSize
								});
								$this.btnList[0].columnList.forEach(function(item, index) {
									item.value = '';
								})
								tip()
							} else {
								$this.utils.tipsAlert(data.message);
							}
						}).catch((response) => {})
					}
				});
			}
			if (this.menuList.indexOf("CD_632") != -1) {
				this.btnList.push({
					btnLabel: '编辑',
					btnType: 4,
					btnPosition: 'left',
					title: '编辑',
					columnList: [{
							columnLabel: '行政编码',
							value: '',
							columnD: true,
							column: 'areaCode',
							columnType: 0,
							placeholder: '请输入行政编码',
						},
						{
							columnLabel: '名称',
							value: '',
							column: 'name',
							columnType: 0,
							placeholder: '请输入名称',
						}, {
							columnLabel: '经度',
							value: '',
							column: 'lng',
							columnType: 0,
							placeholder: '请输入经度',
						},
						{
							columnLabel: '纬度',
							value: '',
							column: 'lat',
							columnType: 0,
							placeholder: '请输入纬度',
						},
					],
					btnClick: function(tip) {
						if (Object.keys($this.tableInfo).length > 0) {
							tip();
							$this.btnList[1].columnList.forEach(function(item, index) {
								item.value = $this.tableInfo[item.column];
							})
						} else {
							$this.utils.tipsAlert('请选择数据');
						}
					},
					btnFun: function(tip, info) {
						if (info.lat == '') {
							this.utils.tipsAlert('纬度不能为空');
							return;
						}
						if (info.lng == '') {
							this.utils.tipsAlert('经度不能为空');
							return;
						}
						if (info.name == '') {
							this.utils.tipsAlert('名称不能为空');
							return;
						}
						if (info.areaCode == '') {
							this.utils.tipsAlert('行政编码不能为空');
							return;
						}
						info.lat = Number(info.lat)
						info.lng = Number(info.lng)
						info.areaCode = Number(info.areaCode)
						$this.utils.startLoading();
						User.updataArea(info).then((response) => {
							const data = response.data;
							if (data.code == 1) {
								$this.utils.endLoading();
								$this.utils.saveAlert();
								$this.search({
									pageNo: 1,
									pageSize: $this.pageSize
								});
								$this.btnList[0].columnList.forEach(function(item, index) {
									item.value = '';
								})
								tip()
							} else {
								$this.utils.tipsAlert(data.message);
							}
						}).catch((response) => {})
					}
				});
			}
			if (this.menuList.indexOf("CD_633") != -1) {
				this.btnList.push({
					btnLabel: '删除',
					btnType: 0,
					btnPosition: 'left',
					btnFun: function() {
						if (Object.keys($this.tableInfo).length > 0) {
							$this.$confirm('是否删除这个区域?', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								var info = [$this.tableInfo.id]
								this.utils.startLoading();
								User.delArea(info).then((response) => {
									const data = response.data;
									if (data.code == 1) {
										this.utils.endLoading();
										$this.utils.delAlert();
									} else {
										$this.utils.tipsAlert(data.message);
									}
									$this.search({
										pageNo: 1,
										pageSize: $this.pageSize
									});
								}).catch((response) => {})
							});
						}
					}
				});
			}
			this.btnList.push({
				btnLabel: '查询',
				btnType: 3,
				btnPosition: 'right',
				btnFun: function() {
					$this.search({
						pageNo: 1,
						pageSize: $this.pageSize
					});
				},
			});
		},
		mounted() {
			this.paddingTop = (this.$refs.search.clientHeight + this.$refs.btnList.clientHeight + 20) + 'px';
			this.getWindowHeight();
			window.onresize = () => {
				this.getWindowHeight();
				this.$refs.list.getHeight();
			}
		}
	}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/system/area.vue